import React from 'react';
import { AtomicBlockUtils, EditorState, Modifier, SelectionState, RichUtils } from "draft-js";
import { updateEntity, filterEmptyBlocks, getAtomicEntityInfo, deprecated, getFileType } from "lib/helpers";
import { createToolbarButtons } from "../createToolbarButtons";
import { ImportProgressBlock, ImportButton, GalleryBlock, AttachmentBlock } from "./component";
import { runImportTask } from "./modifier/runImportTask";

const defaultOptions = {
	buttons: ['spliter', 'word', 'ppt', 'attachment'],
	enable: false,
	maxFileSize: 10 * 1024 * 1024,

	createImportTask: null,

	/** @deprecated */
	handleConvertTask: null,
	/** @deprecated */
	handleQueryPreview: null,
};

const withType = (Button, type) => props => <Button type={type} {...props} />;

const BUTTON_MAP = {
	word: withType(ImportButton, 'word'),
	ppt: withType(ImportButton, 'ppt'),
	attachment: withType(ImportButton, 'attachment'),
}

/**
 * @return {DraftEditorPlugin}
 */
export function createFileImportPlugin(options = defaultOptions) {
	options = { ...defaultOptions, ...options };
	let {
		enable,
		buttons,
		maxFileSize,
		createImportTask,
		handleConvertTask,
		handleQueryPreview,
	} = options;

	if (!enable) {
		return {};
	}

	if (handleConvertTask) {
		deprecated('handleConvertTask 方法请改用 createImportTask 方法实现，否则文件导入无法正常工作');
		return {};
	}

	if (handleQueryPreview) {
		deprecated('handleQueryPreview 方法请改用 queryImportTask 方法实现，否则文件导入无法正常工作');
		return {};
	}

	if (typeof createImportTask !== 'function') {
		throw new Error('createImportTask is required.');
	}

	/**
	 *
	 * @param {DraftEditorStore} store
	 * @param {File[]} files
	 * @param {Draft.SelectionState} selection
	 */
	function performImport(store, files, selection) {
		// convert file list to file array
		if (!Array.isArray(files) && files && files.length) {
			files = [].slice.call(files);
		}
		let fileType = null;
		const file = files.find(file => {
			if (file instanceof File) {
				fileType = getFileType(file.name);
				if (fileType) {
					return true;
				}
			}
			return false;
		});
		if (!file) {
			return 'not-handled';
		}
		selection = selection || store.getEditorState().getSelection();
		runImportTask({
			store,
			file,
			fileType,
			selection,
			maxFileSize,
			createImportTask,
		});
		return 'handled';
	}

	return {
		getToolbarButtons(props) {
			if (props.env !== 'root') {
				return null;
			}
			const editorState = props.store.getEditorState();
			// 代码块不支持文件导入
			if (RichUtils.getCurrentBlockType(editorState) === 'code-block') {
				return null;
			}
			return createToolbarButtons(BUTTON_MAP, buttons, {
				...props,
				onInsert: files => performImport(props.store, files),
			});
		},

		getBlockRenderInfo(block, store) {
			const entityInfo = getAtomicEntityInfo(block, store);
			if (!entityInfo) {
				return;
			}
			switch (entityInfo.entityType) {
				case 'IMPORT': return {
					component: ImportProgressBlock,
					editable: false,
					props: entityInfo,
				};
				case 'GALLERY': return {
					component: GalleryBlock,
					editable: false,
					props: {
						...entityInfo,
						store,
					},
				};
				case 'ATTACHMENT': return {
					component: AttachmentBlock,
					editable: false,
					props: {
						...entityInfo,
						store,
					},
				};
			}
		},

		handleFiles(store, selection, files, type) {
			return performImport(store, files, selection);
		}
	}
}


export function createDocImportPlugin(options) {
	deprecated('docImport 插件已经更改为 fileImport，请改用 createFileImportPlugin 方法');
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/fileImportPlugin/createFileImportPlugin.js